import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { LoaderService } from '../../../app/core/services/loading.service';
import { AppConstants } from '../../../config/app-constants';
import { PROGRAMS_API_ENDPOINTS } from '../../../endpoints.const';

@Injectable({
    providedIn: 'root'
})
export class ProgramService {
    private apiUrl = AppConstants.APP_BASE_API_URL;
    resetDynamicForm = new Subject();
    resetDate = new Subject();
    columnheader: any;
    path: string;
    constructor(public http: HttpClient, public loaderService: LoaderService) { }
    fetchData(payload: any): Observable<any> {
        const headers = new HttpHeaders({
            userId: this.loaderService.getItem('userId')
        });
        let url = `${AppConstants.APP_BASE_API_URL}${PROGRAMS_API_ENDPOINTS.FETCH_DATA}`;
        return this.http.post<any>(url, payload);
    }

    downloadAttachement(payload: any): Observable<any> {
        const headers = new HttpHeaders({
            userId: this.loaderService.getItem('userId')
        });
        let url = `${AppConstants.APP_BASE_API_URL}${PROGRAMS_API_ENDPOINTS.DOWNLOAD_ATTACHMENT}`;
        return this.http.post(url, payload, { responseType: 'arraybuffer', observe: 'response' });
    }

    //Will be changed later

    uploadFile(file: any, srvcRqstId: any, srvcRqstNum: any): Observable<HttpEvent<any>> {
            const headers = new HttpHeaders({
                userId: this.loaderService.getItem('userId')
            });
            const formData: FormData = new FormData();
            for (let i = 0; i < file.length; i++) {
                formData.append('file', file[i]);
            }
            const req = new HttpRequest(
                'POST',
                `${AppConstants.APP_BASE_API_URL}${PROGRAMS_API_ENDPOINTS.UPLOAD_FILES}?srvcRqstId=${srvcRqstId}&srvcRqstNum=${srvcRqstNum}`,
                formData,
                {
                    reportProgress: true,
                    responseType: 'json',
                    headers: headers
                }
            );
    
            return this.http.request(req);
        }

}
